/**
 * 判断是否是安卓手机
 * @return {boolean}
 */
export function isAndroid() {
  return navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1;
}

/**
 * 判断是否是ios
 * @return {boolean}
 */
export function isIOS() {
  // return !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  // ipad存在特殊情况 Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_4) AppleWebKit/605.1.15 (KHTML, like Gecko)
  return !!navigator.userAgent.match(/Mac OS X/);
}

/**
 * 判断是否是微信浏览器
 * @return {boolean}
 */
export function isWeixin() {
  let ua = navigator.userAgent.toLowerCase();
  return ua.match(/MicroMessenger/i) == 'micromessenger';
}

/**
 * 判断是否是在原生app环境内
 * @return {boolean}
 */
export function isNativeEnv() {
  return typeof Android !== 'undefined' || typeof window.webkit !== 'undefined';
}
